module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/bg_bottom-e05a4413cee666b0275892ce2340786e.png";